const testimonials = [
  {
    name: "Jennifer R.",
    location: "Heathrow, Lake Mary, FL",
    rating: 5,
    text: "My husband is an executive at one of the companies along International Parkway, and he discovered his passport had expired three weeks before a client meeting in London. Fast Passport Center processed his renewal in five business days. He made the flight to Heathrow, closed the deal, and the client never knew there was a passport issue. Their team understood the urgency of corporate travel in a way that gave us complete confidence.",
    service: "Passport Renewal",
  },
  {
    name: "David K.",
    location: "Lake Mary, FL",
    rating: 5,
    text: "Our daughter was accepted into a UCF study abroad program in Barcelona with six weeks until departure. We pulled her passport and discovered it had expired a year ago. Panic mode. Fast Passport Center walked us through the new passport process for a young adult, we shipped everything overnight from the UPS Store on International Parkway, and her passport arrived four days later. She made the program and had the summer of her life.",
    service: "New Passport",
  },
  {
    name: "Michelle T.",
    location: "Timacuan, Lake Mary, FL",
    rating: 5,
    text: "We booked a Disney cruise out of Port Canaveral for spring break — our family of five. I checked our passports two weeks before sailing and found that both our children's passports had expired. I thought we were going to lose the entire trip. Fast Passport Center handled both child passports, guided us through the parental consent requirements, and both passports arrived with three days to spare. We made the cruise and the kids still talk about it.",
    service: "Child Passport",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function LakeMaryTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Lake Mary Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Lake Mary professionals, families, and students who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}